var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error-msg"}},[_c('split-text',{attrs:{"type":'words',"classname":'error-copy'}},[_vm._v("Huh? Try Speaking up")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }